import { LocaleImage } from '@/i18n/router';
import { cloudScreenshot } from '@/lib/cloudScreenshots';

/** Keep the portal capture light, consistent with the rest of the Cloud gallery. */
export default function CloudComputeScreenshot({ alt, sizes, className = '', loading = 'lazy', decoding }: {
  alt: string;
  sizes: string;
  className?: string;
  loading?: 'eager' | 'lazy';
  decoding?: 'async' | 'sync' | 'auto';
}) {
  const props = { alt, sizes, width: 1920, height: 1200, loading, decoding };
  const src = cloudScreenshot('/nexus/nexus-compute.webp');
  const srcSet = [640, 960, 1280].map(width => `${cloudScreenshot(`/nexus/nexus-compute-${width}w.webp`)} ${width}w`);
  srcSet.push(`${src} 1920w`);
  return <LocaleImage {...props} src={src} srcSet={srcSet.join(', ')} className={className} />;
}
